import { render, staticRenderFns } from "./Create-Location.vue?vue&type=template&id=a4fad68e"
import script from "./Create-Location.vue?vue&type=script&lang=js"
export * from "./Create-Location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports